import { IReportGroup } from "./interfaces/IReportGroup";

export function getReportUrl(reportGroup: IReportGroup, reportName: string | undefined, id: number): string {
  const url = '/api' + getUrlForId(reportGroup, id)
  const queryString = reportName ? `?Name=${reportName}` : ''
  return `${url}${queryString}`
}

function getUrlForId(reportGroup: IReportGroup, id: number): string {
  return reportGroup.Url.replace('{Id}', id.toFixed(0))
}